import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import "./SvgIcon.scss";
import SvgIconDirectiveController from "./SvgIconDirectiveController";

export default class SvgIconDirective implements IDirective {
    public bindToController = {
        icon: "<mmSvgIcon",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public replace = true;

    public restrict = "A";

    public scope = {};

    public template = '<text class="fas fa-fw" dy=".36em" text-anchor="middle">{{$ctrl.iconGlyph}}</text>';

    public templateNamespace = "svg";

    constructor() {
        this.controller = SvgIconDirectiveController;
    }
}

module("mmGui").directive("mmSvgIcon", () => new SvgIconDirective());
